import React from 'react';
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import chart_img from '../../../assets/images/icons/user-dashboard/chart.png';

const AdminDashboardView = (props) => {
  // if (localStorage.getItem("token") != null && localStorage.getItem("is_admin")) {
  return (
    <div className="container">
      <section className="dashboard-page-title" style={{ padding: '12px' }}>
        <h2>Admin Dashboard</h2>
      </section>
      <section>
        <div className="dashboard-body-area" style={{ width: '100%' }}>
          <div className="dashboard-quicklink-box-area">
            <div className="row">
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box">
                  <h3 className="box-title">Applicants</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">{props.applicant_count}</div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/applicants-dashboard"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box highlight">
                  <h3 className="box-title">Interviews</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">{props.interview_count}</div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/interview-dashboard"
                      className="dashbrd-text-btn"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box">
                  <h3 className="box-title">Candidates</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">{props.candidate_count}</div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/candidates-dashboard"
                      className="dashbrd-text-btn"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box">
                  <h3 className="box-title">Pending Private Jobs</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">
                      {props.private_jobs_count}
                    </div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/private-job"
                      className="dashbrd-text-btn"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box highlight">
                  <h3 className="box-title">Pending Council Jobs</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">
                      {props.council_jobs_count}
                    </div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/council-job"
                      className="dashbrd-text-btn"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dshboard-quicklink-box ">
                  <h3 className="box-title">Live Customer Jobs</h3>
                  <div className="mid-count-area">
                    <div className="big-blue-text">
                      {props.active_jobs_count}
                    </div>
                  </div>
                  <div className="box-action-row">
                    <div className="dashbrd-text-btn">
                      {/* <Link
                      href="/admin/customer-dashboard"
                      className="dashbrd-text-btn"
                    > */}
                      VIEW ALL
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
  // }
  // else if(localStorage.getItem("token") == null){
  //     return(
  //         <Navigate href="/login" />
  //     )
  //     }
  // else {
  // return(
  //     <Navigate href="/dashboard" />
  // )
  // }
};

export default AdminDashboardView;
